import styled from 'styled-components'
import { Icon } from 'components/atoms'

export const Root = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const Label = styled.div`
  background: ${ (props) => props.theme.colors.weiss };
  padding: 7px 11.5px 5px;
  line-height: 16px;
  min-width: 93px;
  margin-right: 20px;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
`

export const MenuIcon = styled(Icon)`
  color: ${ (props) => props.theme.colors.weiss };
  font-size: 24px;
  border-radius: 50%;
  background: ${ (props) => props.theme.colors.hellgruen1 };
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
  cursor: pointer;
`
